// extracted by mini-css-extract-plugin
module.exports = {"related-categories":"related-category-links_related-categories__G3vAn","item-link":"related-category-links_item-link__u42Jh"};